import React from 'react'
import { createNgReactBridgeDirective } from '../../react-bridge'
import { Attackers, Attacker } from '../../../components/monitor'

function Wrapper(directiveValues) {
  const {
    attackers,
    clickHandler,
    remainingAttackers,
    remainingAttackCount,
    remainingDisabled,
    remainingClickHandler
  } = getDirectiveValues(directiveValues)

  const transformedAttackers = attackers.map((attacker) =>
    transformAttacker(attacker, clickHandler)
  )

  const transformedRemainingAttackers =
    remainingAttackers.length > 0
      ? {
          attackerCount: remainingAttackers.length,
          attackCount: remainingAttackCount,
          disabled: remainingDisabled,
          onClick: (e) => remainingClickHandler(remainingAttackers, e)
        }
      : undefined

  return (
    <Attackers
      attackers={transformedAttackers}
      remainingAttackers={transformedRemainingAttackers}
    />
  )
}

function getDirectiveValues({
  attackers,
  clickHandler,
  remainingAttackers,
  remainingAttackCount,
  remainingDisabled,
  remainingClickHandler
}) {
  return {
    attackers: attackers || [],
    clickHandler: clickHandler || (() => ''),
    remainingAttackers: remainingAttackers || [],
    remainingAttackCount: remainingAttackCount || 0,
    remainingDisabled: remainingDisabled || false,
    remainingClickHandler: remainingClickHandler || (() => '')
  }
}

function transformAttacker(
  {
    attacker: name,
    attack_status: status,
    attack_types: attackTypes,
    total_attacks: totalAttacks,
    source_ips: sourceIPs,
    source_name: sourceName,
    unknown,
    disabled = false
  },
  onClick
): Attacker {
  return {
    name,
    status,
    attackTypes,
    totalAttacks,
    sourceIPs,
    sourceName,
    unknown,
    disabled,
    onClick: (e) => onClick(name, e)
  }
}

export const attackers = createNgReactBridgeDirective(
  'reactAttackMonitorAttackers',
  [],
  Wrapper,
  [
    'attackers',
    'clickHandler',
    'remainingAttackers',
    'remainingAttackCount',
    'remainingDisabled',
    'remainingClickHandler'
  ]
)
